import { addSpaceBeforeCapitalLetter } from "src/app/shared/utils/addSpaceBeforeCapitalLetter";

export enum ReceiverType{
    TopUp =1,
    PridProduct =2,
}

export const RetailerTypeData = Object.entries(ReceiverType).filter(e => !isNaN(e[0] as any)).map(e => ({
    value: +e[0],
    name: addSpaceBeforeCapitalLetter(e[1].toString())
  }));